import {Component, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../../../../auth/auth.service';
import {PlantService} from '../../services/plant.service';
import {MasterCustomerService} from '../../services/master-customer.service';
import {IPlant} from '../../interfaces/IPlant';
import {permissions} from '../../../../permissions';
import {Title} from '@angular/platform-browser';

@Component({
    templateUrl: './plant-form.component.html',
    providers: [
        AuthService,
        PlantService,
        MasterCustomerService,
    ]
})

export class PlantFormComponent implements OnInit {

    public permissions = permissions;

    public errors: Array<any> = [];
    public action: String = '';

    public loading = false;
    public record: IPlant;

    constructor(
        private route: ActivatedRoute,
        private plantService: PlantService,
        private router: Router,
        private toastr: ToastrService,
        private title: Title
    ) {
        this.title.setTitle('OES - Plant');
    }

    ngOnInit() {
        this.action = this.route.snapshot.url[2].toString();
        this.record = this.plantService.initialize();

        this.getData();
    }

    getData() {
        if (this.route.snapshot.params.id !== undefined && this.route.snapshot.params.id !== null) {
            this.loading = true;
            this.plantService.getById(this.route.snapshot.params.id).subscribe(plantResult => {
                if (plantResult.success) {
                    this.record = plantResult.data;
                    this.loading = false;
                } else {
                    this.toastr.error('Unable to load data. Please try later!', 'Error');
                    setTimeout(() => {
                        this.loading = false;
                        this.cancelClick();
                    }, 2000);
                    this.loading = false;
                }
            }, () => {
                this.toastr.error('Request timed out', 'Service Error');
                setTimeout(() => {
                    this.loading = false;
                    this.cancelClick();
                }, 2000);
                this.loading = false;
            });
        }
    }

    cancelClick() {
        // this.router.navigate(['order-entry-system/plants']);
        window.history.back();
    }

    saveClick() {
        this.plantService.save(this.record, this.action === 'add').subscribe(result => {
            if (result.success) {
                this.toastr.success('Plant ' + (this.action === 'add' ? 'created' : 'updated') + '!', 'Success');
                this.router.navigate(['order-entry-system/plants']);
            } else {
                this.errors = result.errors;
            }
        }, () => {
            this.toastr.error('Request timed out', 'Service Error');
        });
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/plant/plant-form/plant-form.component.ts